const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear0",
    gradientUnits: "userSpaceOnUse",
    x1: 74.980003,
    y1: 437.019989,
    x2: 437.019989,
    y2: 74.980003,
    gradientTransform: "matrix(0.0273438,0,0,0.0273438,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(93.72549%,28.235294%,42.352941%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(97.647059%,56.078431%,50.196078%)",
      stopOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear0)"
    },
    d: "M 6.226562 10.285156 C 6.265625 10.113281 6.398438 9.976562 6.574219 9.941406 C 6.855469 9.894531 7.144531 9.894531 7.425781 9.941406 C 7.601562 9.976562 7.734375 10.113281 7.773438 10.285156 C 7.816406 10.570312 7.816406 10.855469 7.773438 11.140625 C 7.734375 11.3125 7.601562 11.449219 7.425781 11.484375 C 7.144531 11.53125 6.855469 11.53125 6.574219 11.484375 C 6.398438 11.449219 6.265625 11.3125 6.226562 11.140625 C 6.183594 10.855469 6.183594 10.570312 6.226562 10.285156 Z M 7 1.039062 C 9.835938 1.039062 12.277344 3.039062 12.839844 5.816406 C 13.402344 8.597656 11.929688 11.386719 9.320312 12.492188 C 6.285156 13.773438 2.789062 12.351562 1.507812 9.320312 C 0.226562 6.285156 1.648438 2.789062 4.679688 1.507812 C 5.414062 1.195312 6.203125 1.039062 7 1.039062 M 7 0 C 3.132812 0 0 3.132812 0 7 C 0 10.867188 3.132812 14 7 14 C 10.867188 14 14 10.867188 14 7 C 14 3.132812 10.867188 0 7 0 Z M 7.519531 8.378906 L 7.519531 2.933594 C 7.519531 2.648438 7.285156 2.414062 7 2.414062 C 6.714844 2.414062 6.480469 2.648438 6.480469 2.933594 L 6.480469 8.378906 C 6.480469 8.664062 6.714844 8.898438 7 8.898438 C 7.285156 8.898438 7.519531 8.664062 7.519531 8.378906 Z M 7.519531 8.378906 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcInfo);
export default __webpack_public_path__ + "static/media/ic_info.0a751318deaa1c50f3de8c2b60e3dbb6.svg";
export { ForwardRef as ReactComponent };